import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { FiX, FiUpload, FiEye, FiAlertCircle } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import { jobsDocument } from "../../../../redux/slices/jobsSlice";
import {
  updateProfile,
  uploadCrtDocument,
} from "../../../../redux/slices/profileSlice";

const ResUploadModal = ({
  show,
  onHide,
  onSave,
  applicationId,
  shouldUpdateProfile = false,
  value,
  file,
}) => {
  const dispatch = useDispatch();
  const store = useSelector((state) => state.profile);
  const [selectedOption, setSelectedOption] = useState("");
  const [resumeFile, setResumeFile] = useState(null);
  const [error, setError] = useState("");
  const [uploading, setUploading] = useState(false);

  // Initialize selectedOption and resumeFile from props
  React.useEffect(() => {
    if (show) {
      // Set selectedOption based on value prop
      if (value === true) {
        setSelectedOption("true");
      } else if (value === false) {
        setSelectedOption("false");
      } else {
        setSelectedOption("");
      }

      // Set resumeFile from file prop
      if (file) {
        setResumeFile(file);
      } else {
        setResumeFile(null);
      }

      // Clear error when modal opens
      setError("");
    }
  }, [show, value, file]);

  const resumeOptions = [
    { value: "true", label: "Yes, resume uploaded" },
    { value: "false", label: "No resume uploaded" },
  ];

  const handleSelect = (value) => {
    setSelectedOption(value);
    setError("");
  };
  const handleResumeUpload = async (file) => {
    if (!(file instanceof File)) return;

    const allowedExtensions = ["pdf", "odt", "rtf", "doc", "docx", "jpg", "jpeg", "png", "gif", "bmp", "webp"];
    const fileExt = file.name
      .split(".")
      .pop()
      .toLowerCase();

    if (!allowedExtensions.includes(fileExt)) {
      setError("Only allowed file types: pdf, odt, rtf, doc, docx, jpg, jpeg, png, gif, bmp, webp");
      return;
    }

    setError("");
    setUploading(true);

    const formData = new FormData();
    formData.append("file", file);
    formData.append("document_type", "resume");
    formData.append("document_name", file.name);
    formData.append("description", "User resume");

    try {
      let uploaded;

      // 🔥 CONDITION
      if (shouldUpdateProfile) {
        // ✅ PROFILE API
        const res = await dispatch(uploadCrtDocument(formData)).unwrap();
        uploaded = res?.data || res;

        // 🔥 ALSO update profile
        const profileData = new FormData();
        formData.append(
          "name",
          store?.profileItem?.data?.name ||
            store?.profileItem?.data?.full_name ||
            "",
        );
        profileData.append("resume", uploaded.id);

        dispatch(updateProfile(profileData));
      } else {
        // ✅ APPLY API
        const res = await dispatch(
          jobsDocument({
            applicationId,
            data: formData,
          }),
        ).unwrap();

        uploaded = res?.data || res;
      }

      // ✅ COMMON STATE
      setResumeFile({
        id: uploaded.id,
        url: uploaded.file_url || uploaded.file_path,
        name: file.name,
      });

      setSelectedOption("true");
    } catch (err) {
      console.error("Upload error:", err);
      setError("Upload failed");
    } finally {
      setUploading(false);
    }
  };
  // const handleResumeUpload = async (file) => {
  //   if (!(file instanceof File)) return;

  //   const allowedExtensions = ["pdf", "odt", "rtf", "doc", "docx"];
  //   const fileExt = file.name
  //     .split(".")
  //     .pop()
  //     .toLowerCase();

  //   if (!allowedExtensions.includes(fileExt)) {
  //     setError("Only allowed file types: pdf, odt, rtf,  doc, docx");
  //     return;
  //   }
  //   setError("");
  //   setUploading(true);

  //   const formData = new FormData();
  //   formData.append("file", file);
  //   formData.append("document_type", "resume");
  //   formData.append("document_name", file.name);
  //   formData.append("description", "User resume");

  //   try {
  //     const res = await dispatch(
  //       jobsDocument({
  //         applicationId,
  //         data: formData,
  //       }),
  //     ).unwrap();

  //     const uploaded = res?.data || res;

  //     setResumeFile({
  //       id: uploaded.id,
  //       url: uploaded.file_url || uploaded.file_path,
  //       name: file.name,
  //     });

  //     setSelectedOption("true");
  //   } catch (err) {
  //     console.error("Upload error:", err);
  //     setError("Upload failed");
  //   } finally {
  //     setUploading(false); // ✅ ALWAYS RUNS
  //   }
  // };

  const handleSave = () => {
    if (!selectedOption) {
      setError("Please select an option");
      return;
    }

    const finalValue = selectedOption === "true";

    if (onSave) {
      onSave(finalValue, resumeFile);
    }

    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      dialogClassName="custom-modal profile-other-details-modal"
    >
      <Modal.Header>
        <h5 className="modal-title">Have you uploaded your resume?</h5>

        <Button className="close-btn" onClick={onHide}>
          <FiX size={24} />
        </Button>
      </Modal.Header>

      <Modal.Body>
        <div className="radio-options">
          <div className="row">
            {resumeOptions.map((option) => (
              <div
                key={option.value}
                className={`radio-option col-lg-6 ${
                  selectedOption === option.value ? "selected" : ""
                }`}
                onClick={() => handleSelect(option.value)}
              >
                <div className="contentwrap d-flex justify-content-between align-items-center">
                  <div>
                    <input
                      type="radio"
                      checked={selectedOption === option.value}
                      readOnly
                    />
                    <label className="radio-label">{option.label}</label>
                  </div>

                  {option.value === "true" && selectedOption === "true" && (
                    <div
                      className="d-flex gap-2"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <label>
                        <FiUpload />

                        <input
                          type="file"
                          hidden
                          onChange={(e) => {
                            e.preventDefault(); // ✅ STOP reload
                            e.stopPropagation(); // ✅ STOP bubbling
                            handleResumeUpload(e.target.files[0]);
                          }}
                        />
                      </label>

                      {/* {resumeFile?.url && (
                      <a
                        href={resumeFile.url}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <FiEye />
                      </a>
                    )} */}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {error && (
          <div
            className="alert alert-danger mt-3 d-flex align-items-center"
            role="alert"
            style={{ fontSize: "14px", padding: "10px 15px" }}
          >
            <FiAlertCircle
              className="me-2"
              size={18}
              style={{ flexShrink: 0 }}
            />
            <div>{error}</div>
          </div>
        )}

        <div className="text-center mt-4">
          <Button onClick={handleSave} disabled={uploading}>
            {uploading ? "Uploading..." : "Save"}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ResUploadModal;
